import React from 'react';
export default function ChevronUpIcon(props: React.SVGProps<SVGSVGElement>) {
  return <svg xmlns="http://www.w3.org/2000/svg" width="15" height="8" viewBox="0 0 15 8" fill="none" data-sentry-element="svg" data-sentry-component="ChevronUpIcon" data-sentry-source-file="chevronUpIcon.tsx">
      <path d="M14.1406 7.07027L7.07063 0.00027261L0.000624719 7.07027L0.710625 7.78027L7.07063 1.42027L13.4306 7.78027L14.1406 7.07027Z" fill="#4A26FF" data-sentry-element="path" data-sentry-source-file="chevronUpIcon.tsx" />
    </svg>;
}